export default __webpack_public_path__ + "static/media/twitterwhite.c44ebf8b.svg";